/* LittleBird PDP  ·  lb-pdp.js
   Small, dependency-free interactions. Accordions use native <details>,
   sticky add-to-cart is handled by the Prestige theme setting. */
(function () {
  function initDimensions(root) {
    var tabs = root.querySelectorAll('.lb-dim-tabs button');
    var views = root.querySelectorAll('.lb-dim-view');
    if (!tabs.length) return;
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-view');
        tabs.forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
        views.forEach(function (v) { v.classList.toggle('is-active', v.getAttribute('data-view') === id); });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-lb-dimensions]').forEach(initDimensions);

    // "View dimensions" links scroll to the dimensions section, if present.
    document.querySelectorAll('[data-lb-scroll-dims]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var target = document.querySelector('[data-lb-dimensions]');
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
      });
    });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  // Re-init after Shopify theme-editor section loads
  document.addEventListener('shopify:section:load', boot);
})();
